function toggleBestandsInfo() {
  const el = document.getElementById('bestandsbadge-info-details');
  const trigger = document.querySelector('.bestandsbadge-info');

  if (el.classList.contains('expanded')) {
    el.classList.remove('expanded');
  } else {
    el.classList.add('expanded');
  }

  // 🧼 Fokus zurücksetzen, damit der grüne Hovereffekt verschwindet
  trigger.blur();
}
